<template>
  <div class="general" v-show="isActive" v-if="generalContent">
    <div class="html-content"
      v-if="generalContent.BodyText.length > 0"
      v-html="generalContent.BodyText"
    ></div>
   
    <div id="accordion" class="accordion">
      <div
        class="card"
        v-for="(accordion, i) in generalContent.Accordions"
        :key="accordion.Title"
      >
        <button tabindex="0" class="card-header collapsed" data-toggle="collapse" :aria-controls="`heading-${i}`" :href="`#heading-${i}`" aria-expanded="false" >
          <div class="btn">
            {{ accordion.Title }}<!--  <i class="fa fa-plus"></i> -->
          </div>
        </button>
        <div
          :id="`heading-${i}`"
          class="collapse"
          data-parent="#accordion"
        >
          <div class="card-body html-content" v-html="accordion.BodyText"></div>
        </div>

        <!-- <h3
          @click="toggleAccordion(i)"
          ref="accordionTitle"
          :class="{ active: activeAccordion === i }"
        >
          {{ accordion.Title }}
        </h3>
        <div
          ref="accordionBody"
          v-html="accordion.BodyText"
          v-show="activeAccordion === i"
        ></div> -->
      </div>
    </div>
    <div class="space"></div>
  </div>
</template>

<script>
export default {
  name: "OverviewGeneralPage",
  data() {
    return {
      isActive: true,
      activeAccordion: -1
    };
  },
  props: {
    generalContent: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    toggleAccordion(i) {
      if (this.activeAccordion === i) {
        this.activeAccordion = -1; //hide accordion if already active
      } else {
        this.activeAccordion = i;
      }
    }
  }
};
</script>

<style lang="sass" scoped></style>
